import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';
// Migrated 1:1 from @nexato/nx-core-module (activity/components/activity-comment-created-create-command/activity-comment-created-create-command.component.ts, #683)
import { ActivityOwner } from '../../../entities/activity/activity-owner';
import { CommandInput, CommandTemplate } from '../../../entities/commandTemplate/commandTemplate';
import { CommandService, Reloadable } from '../../../services/command/command.service';
import { RefetchCoordinator } from '../../../services/refetch-coordinator/refetch-coordinator.service';
import { RolesService } from '../../../services/roles/roles.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: "nx-activity-comment-created-create-command",
  templateUrl: "activity-comment-created-create-command.html",
  host: {
    'class': 'nx-activity-comment-created-create-command'
  },
  styleUrls: ["./activity-comment-created-create-command.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityCommentCreatedCreateCommandComponent {

  private readonly destroyRef = inject(DestroyRef);
  private readonly commandService = inject(CommandService);
  private readonly rolesService = inject(RolesService);

  readonly commandTemplate = signal<CommandTemplate | undefined>(undefined);
  readonly hasCreatePermission = this.rolesService.hasRole('framework_activity_create');
  readonly commandName = 'noteCreateCommand';
  readonly text = signal<string | undefined>(undefined);
  readonly isEditorEmpty = signal(true);

  readonly owner = input<ActivityOwner>();
  readonly reloadable = input<Reloadable>();
  readonly reloaded = output<void>();

  private previousOwnerId: string | undefined;

  constructor() {
    effect(() => {
      const currentOwner = this.owner();
      if (currentOwner && currentOwner.id !== this.previousOwnerId) {
        this.previousOwnerId = currentOwner.id;
        this.loadCommand();
      }
    });
  }

  loadCommand(): void {
    this.commandService.getCommandByCommandInput(this.buildCommandInput())
      .pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(response => {
        if (response.data.getCommandByCommandInput) {
          this.commandTemplate.set(new CommandTemplate(response.data.getCommandByCommandInput));
        }
      });
  }

private buildCommandInput(): CommandInput {
  const commandInput = new CommandInput();
  commandInput.name = this.commandName;
  const owner = this.owner();
  const obj = {
    ownerId: owner?.id,
    ownerType: owner?.entityType
  };
  commandInput.addParameter("noteInput", obj);  // statt "activityEventInput"
  return commandInput;
}

save(): void {
  const template = this.commandTemplate();
  const owner = this.owner();
  if (!template || !owner) return;

  const commandInput = new CommandInput();
  commandInput.name = template.name;
  commandInput.addParameter("noteInput", {
    ownerId: owner.id,
    ownerType: owner.entityType,
    content: this.text()  // oder als JSON-Objekt wenn TipTap: { type: "doc", content: [...] }
  });
  this.commandService.sendCommand(commandInput, () => {
    this.text.set(undefined);
    this.loadCommand();
    this.reloaded.emit();
  });
}

  onEmptyStateChange(isEmpty: boolean): void {
    this.isEditorEmpty.set(isEmpty);
  }
}
